/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TeamSubscriptionDto = {
    teamId?: number;
    teamName?: string;
    teamType?: TeamSubscriptionDto.teamType;
    subscriptionName?: string;
    endDate?: string;
    seasonDefinitionIds?: Array<number>;
};
export namespace TeamSubscriptionDto {
    export enum teamType {
        SENIOR = 'SENIOR',
        YOUTH = 'YOUTH',
    }
}
